module.exports = __webpack_public_path__ + "index_pc/img/hejie2.a4515e57.png";